export default __webpack_public_path__ + "static/media/ig.c438fc1e.svg";